import { AgentCompanyDetail as AgentCompanyDetailComponent } from './AgentCompanyDetail.component';
import { connector } from './AgentCompanyDetail.connector';

export const AgentCompanyDetail = connector(AgentCompanyDetailComponent);
